import { Address } from '../models/users/dto/address';
import { State } from '../models/types/dto/state';
import { Country } from '../models/types/dto/country';

export class AddressUtils {
  // Check if two addresses are equal, ignoring ID because it is a GUID.
  public static areAddressesEqual(a: Address, b: Address, ignoreAttention: boolean = false): boolean {
    return (
      (ignoreAttention || a.attention === b.attention) &&
      a.addressLine1 === b.addressLine1 &&
      a.addressLine2 === b.addressLine2 &&
      a.addressLine3 === b.addressLine3 &&
      a.city === b.city &&
      a.stateId === b.stateId &&
      a.countryId === b.countryId &&
      a.postalCode === b.postalCode &&
      this.areStatesEqual(a.state, b.state) &&
      this.areCountriesEqual(a.country, b.country)
    );
  }

  public static areStatesEqual(a: State, b: State): boolean {
    return (
      a.id === b.id &&
      a.stateCode === b.stateCode &&
      a.countryId === b.countryId &&
      a.countryCode === b.countryCode &&
      a.countryName === b.countryName &&
      a.name === b.name
    );
  }

  public static areCountriesEqual(a: Country, b: Country): boolean {
    return a.id === b.id && a.countryCode === b.countryCode && a.phoneCode === b.phoneCode && a.name === b.name;
  }
}
